export const fileImportHeaders = [
	{name: 'name', required: true},
	{name: 'message', required: true},
	{name: 'description', required: false},
];
